module.exports = __webpack_public_path__ + "img/header_7.04e70907.jpg";